
import { parse } from 'query-string'
import { mapGetters } from 'vuex'

import SkinnyBanner from '@core/components/SkinnyBanner'
import { removeEmptyValuesInObject } from '@core/helpers'
import { getDevice } from '@tracking'

import SearchParams, { getSourceFromRouteName } from '../../utils/SearchParams'
import ProductResultsSection from '../ProductResults/ProductResultsSection.vue'

export const fetch = async ({ store, route }) => {
  // Note that the hash is not available server-side, but is client-side.
  const { query, hash, name, params } = route
  const source = getSourceFromRouteName(name)

  store.dispatch('landing/reset')
  await store.dispatch('landingSearch/fetchResults', {
    searchParams: new SearchParams({
      query,
      hash,
      context: {
        source,
        slug: params?.merchantName,
        id: params.uuid,
      },
      paramsWhitelist: store.getters['landingSearch/filterWhitelist'],
      tags: [getDevice(), source],
    }),
  })
}

export default {
  components: {
    SkinnyBanner,
    ProductResultsSection,
  },

  computed: {
    ...mapGetters({
      isSkinnyBannerAvailable: 'countryConfig/isSkinnyBannerAvailable',
      filterWhitelist: 'landingSearch/filterWhitelist',
      searchHasResults: 'landingSearch/hasResults',
    }),
    searchContext() {
      const { params, name } = this.$route

      return removeEmptyValuesInObject({
        source: getSourceFromRouteName(name),
        slug: params?.merchantName,
        id: params.uuid,
      })
    },
    searchParams() {
      const { query, hash, name } = this.$route

      return new SearchParams({
        query,
        hash,
        context: this.searchContext,
        paramsWhitelist: this.filterWhitelist,
        tags: [getDevice(), getSourceFromRouteName(name)],
      })
    },
    searchFilters() {
      return this.searchParams.toFilters()
    },
    hasFilters() {
      return this.searchParams.hasUserFilters()
    },
  },

  watch: {
    '$route.hash': 'fetchSearchResults',
    '$route.query': 'fetchSearchResults',
  },

  mounted() {
    if (this.hasFilters) {
      this.fetchSearchResults()
    }
  },

  methods: {
    async fetchSearchResults() {
      await this.$store.dispatch('landingSearch/fetchResults', {
        searchParams: this.searchParams,
      })
    },

    updateQueryString(filter) {
      const filters = {
        ...this.searchFilters,
        page: 1,
        context: this.searchContext,
        paramsWhitelist: this.filterWhitelist,
        ...filter,
      }

      const query = SearchParams.fromFilters(filters).toQueryParams()

      this.updateURLFromFilters(query)
    },

    resetFilters() {
      const { q } = this.searchFilters
      this.updateURLFromFilters({
        ...(q && { query: { q } }),
      })
    },

    updateURLFromFilters({ hash, query }) {
      this.$navigation.push({
        name: this.$route.name,
        params: this.$route.params,
        hash: parse(hash),
        query,
        type: 'internal',
      })
    },
  },
}
